export const tryParseJSON = <TObj extends object>(
    jsonString: string,
    errorHandler?: (error: Error) => {}
): TObj | false => {
    try {
        return JSON.parse(jsonString);
    } catch (error) {
        errorHandler && errorHandler(error);
        return false;
    }
};
